<div class="navbar-area fixed-top" id="main-navbar">
    <div class="row bg-white">
        <div class="container">
            <nav class="navbar navbar-expand-lg navbar-light bg-white">
                <a class="navbar-brand" routerLink="/"><img src="{{logoPath}}" alt="logo"></a>
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo02"
                        aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>

                <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
                    <ul class="navbar-nav m-auto">

                        <li class="nav-item">
                            <a routerLink="/joburi" class="nav-link" routerLinkActive="active"
                               [routerLinkActiveOptions]="{exact: true}">{{'NAVBAR.jobs' | translate}}</a>
                        </li>

                        <li class="nav-item">
                            <div class="btn-group flex-wrap">
                                <a routerLink="/companii" routerLinkActive="active"
                                   class="nav-link main-link">{{'NAVBAR.companies' | translate}}</a>
                                <a class="nav-link dropdown-toggle dropdown-toggle-split" data-toggle="dropdown"
                                   aria-haspopup="true" aria-expanded="false">
                                    <i class="icofont-simple-down"></i>
                                </a>
                                <div class="dropdown-menu">
                                    <a routerLink="/companii" class="dropdown-item"
                                    routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}">{{'NAVBAR.companies' | translate}}</a>
                                    <a routerLink="/servicii-agri-jobs" class="dropdown-item"
                                       routerLinkActive="active"
                                       [routerLinkActiveOptions]="{exact: true}">{{'NAVBAR.SERVICES' | translate}}</a>
                                    <a routerLink="/pachete" class="dropdown-item"
                                       routerLinkActive="active"
                                       [routerLinkActiveOptions]="{exact: true}">{{'NAVBAR.OFFER' | translate}}</a>

                                    <a routerLink="/brand-de-angajator" class="dropdown-item"
                                       routerLinkActive="active"
                                       [routerLinkActiveOptions]="{exact: true}">{{'NAVBAR.brand' | translate}}</a>
                                </div>
                            </div>
                        </li>

                        <li class="nav-item">
                            <div class="btn-group flex-wrap">
                                <a routerLink="/consiliere-si-orientare-cariera" class="nav-link main-link" routerLinkActive="active">{{'NAVBAR.career' | translate}}</a>
                                <a class="nav-link dropdown-toggle dropdown-toggle-split" data-toggle="dropdown"
                                   aria-haspopup="true" aria-expanded="false">
                                    <i class="icofont-simple-down"></i>
                                </a>
                                <div class="dropdown-menu">
                                    <a routerLink="/consiliere-si-orientare-cariera" class="dropdown-item"
                                       routerLinkActive="active"
                                       [routerLinkActiveOptions]="{exact: true}">{{'NAVBAR.careerCounseling' | translate}}</a>
                                    <a routerLink="/comparator-salarii" class="dropdown-item"
                                       routerLinkActive="active"
                                       [routerLinkActiveOptions]="{exact: true}">{{'NAVBAR.salary' | translate}}</a>
                                </div>
                            </div>
                        </li>

                        <li class="nav-item">
                            <a routerLink="/blog" class="nav-link" routerLinkActive="active"
                               [routerLinkActiveOptions]="{exact: true}">Blog</a>
                        </li>

                        <li class="nav-item">
                            <div class="btn-group flex-wrap">
                                <a class="nav-link main-link" routerLink="/abj-despre" routerLinkActive="active">{{'NAVBAR.about' | translate}}</a>
                                <a class="nav-link dropdown-toggle dropdown-toggle-split" data-toggle="dropdown"
                                   aria-haspopup="true" aria-expanded="false">
                                    <i class="icofont-simple-down"></i>
                                </a>
                                <div class="dropdown-menu">
                                    <a routerLink="/abj-staff" class="dropdown-item" routerLinkActive="active"
                                       [routerLinkActiveOptions]="{exact: true}">{{'NAVBAR.staff' | translate}}</a>
                                    <a routerLink="/abj-specialisti" class="dropdown-item" routerLinkActive="active"
                                       [routerLinkActiveOptions]="{exact: true}">{{'NAVBAR.specialists' | translate}}</a>
                                    <a routerLink="/abj-juniori" class="dropdown-item" routerLinkActive="active"
                                       [routerLinkActiveOptions]="{exact: true}">{{'NAVBAR.juniors' | translate}}</a>
                                    <a routerLink="/recomanda" class="dropdown-item" routerLinkActive="active"
                                       [routerLinkActiveOptions]="{exact: true}">{{'NAVBAR.recommend' | translate}}</a>
                                </div>
                            </div>
                        </li>


                        <li class="nav-item">
                            <a routerLink="/contact" class="nav-link" routerLinkActive="active"
                               [routerLinkActiveOptions]="{exact: true}">Contact</a>
                        </li>

                    </ul>
                    <div class="my-2 my-lg-0">
                        <div class="right-sidebar common-btn" *ngIf="!isLoggedIn">
                            <ul class="navbar-nav">
                                <li class="nav-item  d-flex align-items-center">
                                    <a class="mr-5" routerLink="/inregistrare">
                                        <i class="icofont-user-alt-4 mr-1"></i>
                                        {{'NAVBAR.register' | translate}}
                                    </a>
                                </li>
                                <li class="nav-item  d-flex align-items-center">
                                    <a class="mr-5" routerLink="/autentificare"><i class="icofont-lock mr-1"></i>{{'NAVBAR.login' | translate}}</a>
                                </li>
                                <li class="nav-item d-flex align-items-center">
                                    <i class="icofont-globe mr-1"></i>
                                    <select [(ngModel)]="selectLanguage" (change)="useLanguage(selectLanguage)"
                                            class="select2-container">
                                        <option *ngFor="let language of languageOptions"
                                                value="{{language.id}}">{{language.name}}</option>
                                    </select>
                                </li>

                            </ul>
                        </div>

                        <div class="right-sidebar" *ngIf="isLoggedIn">
                            <ul class="navbar-nav">
                                <!--Companies-->
                                <li class="nav-item">
                                    <div class="btn-group flex-wrap">
                                        <a routerLink="/cont"
                                           class="nav-link main-link" routerLinkActive="active"><i
                                                class="icofont-user-alt-4 mr-1" routerLinkActive="active"></i> {{'ACCOUNT.MY_ACCOUNT' | translate}} </a>
                                        <a class="nav-link dropdown-toggle dropdown-toggle-split" data-toggle="dropdown"
                                           aria-haspopup="true" aria-expanded="false">
                                            <i class="icofont-simple-down"></i>
                                        </a>
                                        <div class="dropdown-menu" *ngIf="userRole === 'client'">
                                            <a routerLink="/cont/editare" class="dropdown-item"
                                               routerLinkActive="active"
                                               [routerLinkActiveOptions]="{exact: true}">{{'ACCOUNT.PROFILE_EDIT' | translate}}</a>
                                            <a routerLink="/compania-mea" class="dropdown-item"
                                               routerLinkActive="active"
                                               [routerLinkActiveOptions]="{exact: true}">{{'ACCOUNT.MY_COMPANY' | translate}}</a>
                                            <a routerLink="/adauga-job" class="dropdown-item"
                                               routerLinkActive="active"
                                               [routerLinkActiveOptions]="{exact: true}">{{'ACCOUNT.ADD_JOB' | translate}}</a>
                                            <a routerLink="/joburile-mele" class="dropdown-item"
                                               routerLinkActive="active"
                                               [routerLinkActiveOptions]="{exact: true}">{{'ACCOUNT.MY_JOBS' | translate}}</a>
                                        </div>
                                        <div class="dropdown-menu" *ngIf="userRole === 'candidate'">
                                            <a routerLink="/profilul-meu" class="dropdown-item"
                                               routerLinkActive="active"
                                               [routerLinkActiveOptions]="{exact: true}">{{'ACCOUNT.PROFILE_CANDIDATE' | translate}}</a>
                                            <a routerLink="/editeaza-profilul" class="dropdown-item"
                                               routerLinkActive="active"
                                               [routerLinkActiveOptions]="{exact: true}">{{'ACCOUNT.PROFILE_EDIT' | translate}}</a>
                                            <a (click)="generatePdf()" class="dropdown-item">{{'ACCOUNT.VIEW_CV' | translate}}</a>
                                            <a routerLink="/aplicatiile-mele" class="dropdown-item"
                                            routerLinkActive="active"
                                            [routerLinkActiveOptions]="{exact: true}">{{'ACCOUNT.MY_APPLICATIONS' | translate}}</a>
                                            <a routerLink="/joburi-favorite" class="dropdown-item"
                                               routerLinkActive="active"
                                               [routerLinkActiveOptions]="{exact: true}">{{'ACCOUNT.FAVORITE_JOBS' | translate}}</a>

                                        </div>
                                    </div>
                                </li>
                                <li class="nav-item  d-flex align-items-center">
                                    <a (click)="onLogout()" class="mr-5 nav-link" href="https://agribusinessjob.ro:9595/agri/logout"><i class="icofont-exit mr-1"></i>Logout</a>
                                </li>
                                <li class="nav-item d-flex align-items-center nav-link">
                                    <i class="icofont-globe mr-1"></i>
                                    <select [(ngModel)]="selectLanguage" (change)="useLanguage(selectLanguage)"
                                            class="select2-container">
                                        <option *ngFor="let language of languageOptions"
                                                value="{{language.id}}">{{language.name}}</option>
                                    </select>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    </div>
</div>

<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <ng-content select="h2"></ng-content>
                </div>
                <div class="breadcrumb-row">
                    <breadcrumb prefix="{{'LOGIN.HOME' | translate}}"></breadcrumb>
                </div>
                <div class="main-details">
                    <ng-content select="div"></ng-content>
                </div>
            </div>
        </div>
    </div>
</div>
